import { render } from "./Index.vue?vue&type=template&id=50bce0fc"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=50bce0fc&lang=css"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/price-managment/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50bce0fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50bce0fc', __exports__)) {
    console.log('reload')
    api.reload('50bce0fc', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=50bce0fc", () => {
    console.log('re-render')
    api.rerender('50bce0fc', render)
  })

}


export default __exports__